"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoutScene = void 0;
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("../../config");
const routes_1 = require("../../routes");
const Loading_1 = require("../../components/Loading/Loading");
const requests_1 = require("../../requests");
exports.LogoutScene = () => {
    const [redirect, setRedirect] = react_1.useState('');
    const afterRequest = () => {
        config_1.destroyAccessInformation().then(() => setRedirect(routes_1.routes.LOGIN));
    };
    react_1.useEffect(() => {
        config_1.getAccessInformation()
            .then(({ accessToken }) => requests_1.logoutRequest(accessToken))
            .then(afterRequest)
            .catch(afterRequest);
    }, []);
    if (redirect)
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: redirect });
    return react_1.default.createElement(Loading_1.Loading, { centeredVertical: true });
};
//# sourceMappingURL=LogoutScene.js.map